import React, { useState, useRef, useEffect } from "react";
import "./GestionEditoriale.scss";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import { updateAdmin } from "Redux/Actions/adminActions";
import {
  findManagementContentByLabel,
  formatDateHourFrenchLocale,
  sanitizeHtml,
} from "Services/functions";
import { Toast } from "primereact/toast";
import axios from "axios";
import ReactQuill from "react-quill";
import parse from "html-react-parser";
import QuillOptions from "Components/QuillOptions/QuillOptions";
import { HTMLParseOptions } from "Services/htmlParseOptions";

/**
 * Permet d'afficher la page de gestion éditoriale
 * Page accessible uniquement pour les administrateurs
 */
const GestionEditoriale = (props) => {
  const API_LINK = process.env.REACT_APP_BASE_URL_API.split("/api")[0];

  const [presentationRP, setPresentationRP] = useState({});
  const [presentationRPAlumni, setPresentationRPAlumni] = useState({});
  const [partieRP, setPartieRP] = useState({});
  const [presentationUniv, setPresentationUniv] = useState({});
  const [rejoindreRP, setRejoindreRP] = useState({});
  const [charteRP, setCharteRP] = useState({});
  const [charteRPAlumni, setCharteRPAlumni] = useState({});

  const [loading, setLoading] = useState(false);

  const successUpdate = useRef(null);
  const [openMenu, setOpenMenu] = useState("presentationRP");

  function setContent(itemName) {
    return (
      findManagementContentByLabel(
        itemName,
        props.admin.editManagement,
        props.admin.editManagementNexus,
        props.auth.universityConnected.id
      ) || {
        content: "",
        updatedAt: "",
      }
    );
  }

  useEffect(() => {
    setPresentationRP(setContent("presentationRP"));
    setPresentationRPAlumni(setContent("presentationRPAlumni"));
    setPartieRP(setContent("partieRP"));
    setPresentationUniv(setContent("presentationUniv"));
    setRejoindreRP(setContent("rejoindreRP"));
    setCharteRP(setContent("charteRP"));
    setCharteRPAlumni(setContent("charteRPAlumni"));
  }, [props.admin.editManagementNexus, props.admin.editManagement]);

  // fonction permettant de faire apparaitre la partie droite au niveau du scss
  function setClass(item) {
    if (item == openMenu) {
      return "Ouvert";
    } else {
      return "nonOuvert";
    }
  }
  const putDataToApi = async () => {
    const objToUpdate = props.admin.editManagement.find(
      (item) => item.label === openMenu
    );
    let content = null;
    switch (openMenu) {
      case "presentationRP":
        content = presentationRP?.content;
        break;
      case "presentationRPAlumni":
        content = presentationRPAlumni?.content;
        break;
      case "partieRP":
        content = partieRP?.content;
        break;
      case "presentationUniv":
        content = presentationUniv?.content;
        break;
      case "rejoindreRP":
        content = rejoindreRP?.content;
        break;
      case "charteRP":
        content = charteRP?.content;
        break;
      case "charteRPAlumni":
        content = charteRPAlumni?.content;
        break;
      default:
        break;
    }
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL_API}/editorial_management/${objToUpdate.id}/edit_content`,
        { content },
        {
          headers: props.auth.token
            ? {
                accept: "application/json",
                "Content-Type": "application/json",

                Authorization: `Bearer ${props.auth.token}`,
              }
            : {
                accept: "application/json",
                "Content-Type": "application/json",
              },
        }
      )
      .then(async (res) => {
        if (res.status === 201) await fetchEditorialManagement();
      })
      .catch((error) =>
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        })
      )
      .finally(() => setLoading(false));
  };

  //? Fonction pour appeler le Toast
  const showSuccess = () => {
    successUpdate.current.show({
      severity: "success",
      summary: "Mise à jour effectuée avec succès",
      detail: "Votre mise à jour a bien été prise en compte",
      life: 3000,
    });
  };

  //? Composant qui permet de retourner la date de mise à jour de l'élément cliqué si il a déjà été modifié
  const findDate = (itemName) => {
    let objFindWithUnivConnected = null;

    switch (itemName) {
      case "presentationRP":
        objFindWithUnivConnected = presentationRP;
        break;
      case "presentationRPAlumni":
        objFindWithUnivConnected = presentationRPAlumni;
        break;
      case "partieRP":
        objFindWithUnivConnected = partieRP;
        break;
      case "presentationUniv":
        objFindWithUnivConnected = presentationUniv;
        break;
      case "rejoindreRP":
        objFindWithUnivConnected = rejoindreRP;
        break;
      case "charteRP":
        objFindWithUnivConnected = charteRP;
        break;
      case "charteRPAlumni":
        objFindWithUnivConnected = charteRPAlumni;
        break;
      default:
        break;
    }

    return objFindWithUnivConnected ? (
      <>
        <h6>
          Dernière modification le&nbsp;
          <strong>
            {formatDateHourFrenchLocale(objFindWithUnivConnected?.updatedAt)}
          </strong>
        </h6>
        <img
          src={
            API_LINK +
            props.universities.universitiesData.find(
              (univ) =>
                univ.id == objFindWithUnivConnected?.editedByUniversity?.id
            )?.imageUrl
          }
          alt={
            "Logo Université " +
            props.universities.universitiesData.find(
              (univ) =>
                univ.id == objFindWithUnivConnected?.editedByUniversity?.id
            )?.name
          }
          title={
            "Logo Université " +
            props.universities.universitiesData.find(
              (univ) =>
                univ.id == objFindWithUnivConnected?.editedByUniversity?.id
            )?.name
          }
        />
      </>
    ) : (
      <h6>Elément jamais modifié</h6>
    );
  };

  const errorLimitMessage = (itemToFind, limitNumber) => {
    const currentContent = parse(
      sanitizeHtml(
        props.admin.editManagement.find((item) => item.label == itemToFind)
          ?.contentManagement[0]?.content
      ),
      HTMLParseOptions
    );
    const currentContentLength = currentContent?.props?.children?.length;
    return (
      currentContentLength > limitNumber && (
        <p className="errorMessageCaracterLimits">
          {`Votre texte ne peut pas dépasser ${limitNumber} caractères, actuellement: ${currentContentLength}/${limitNumber}`}
        </p>
      )
    );
  };

  async function updateNexus() {
    let nexus = await axios.get(
      `${process.env.REACT_APP_NEXUS_URL_API}/editorial_managements`,
      {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    props.handleAdmin({
      ...props.admin,
      editManagementNexus: nexus?.data || [],
    });
  }

  async function updateUniv() {
    let univ = await axios.get(
      `${process.env.REACT_APP_BASE_URL_API}/editorial_managements`,
      {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    showSuccess();

    props.handleAdmin({
      ...props.admin,
      editManagement: univ?.data || [],
    });
  }

  async function fetchEditorialManagement() {
    await updateNexus();
    await updateUniv();
  }

  //? Rendu du composant à droite en fonction de la navbar de gauche
  function getContent(item) {
    switch (item) {
      case "presentationRP":
        return (
          <>
            <h2>Présentation Réseau Pro</h2>
            <h6>Présentation Réseau Pro (500 caractères max)</h6>
            <ReactQuill
              theme="snow"
              modules={QuillOptions.modules}
              formats={QuillOptions.formats}
              rows={5}
              name="presentationRP"
              value={presentationRP.content}
              onChange={(e) =>
                setPresentationRP({
                  ...presentationRP,
                  content: e,
                })
              }
            />
            {errorLimitMessage("presentationRP", 500)}
          </>
        );
      case "presentationRPAlumni":
        return (
          <>
            <h2>Présentation Réseau Pro Alumni</h2>
            <h6>Présentation Réseau Pro Alumni (500 caractères max)</h6>
            <ReactQuill
              theme="snow"
              modules={QuillOptions.modules}
              formats={QuillOptions.formats}
              rows={5}
              name="presentationRPAlumni"
              value={presentationRPAlumni.content}
              onChange={(e) =>
                setPresentationRPAlumni({
                  ...presentationRPAlumni,
                  content: e,
                })
              }
            />
            {errorLimitMessage("presentationRPAlumni", 500)}
          </>
        );
      case "partieRP":
        return (
          <>
            <h2>Nos universités</h2>
            <h6>Comment faire partie de Réseau Pro (550 caractères max)</h6>
            <ReactQuill
              theme="snow"
              modules={QuillOptions.modules}
              formats={QuillOptions.formats}
              rows={5}
              name="partieRP"
              value={partieRP.content}
              onChange={(e) =>
                setPartieRP({
                  ...partieRP,
                  content: e,
                })
              }
            />
            {errorLimitMessage("partieRP", 550)}
          </>
        );
      case "presentationUniv":
        return (
          <>
            <h2>Nos universités</h2>
            <h6>Présentation de votre université (550 caractères max)</h6>
            <ReactQuill
              theme="snow"
              modules={QuillOptions.modules}
              formats={QuillOptions.formats}
              rows={5}
              name="presentationUniv"
              value={presentationUniv.content}
              onChange={(e) =>
                setPresentationUniv({
                  ...presentationUniv,
                  content: e,
                })
              }
            />
            {errorLimitMessage("presentationUniv", 550)}
          </>
        );
      case "rejoindreRP":
        return (
          <>
            <h2>Espace recruteur</h2>
            <h6>Comment rejoindre Réseau Pro (550 caractères max)</h6>
            <ReactQuill
              theme="snow"
              modules={QuillOptions.modules}
              formats={QuillOptions.formats}
              rows={5}
              name="rejoindreRP"
              value={rejoindreRP.content}
              onChange={(e) =>
                setRejoindreRP({
                  ...rejoindreRP,
                  content: e,
                })
              }
            />
            {errorLimitMessage("rejoindreRP", 550)}
          </>
        );
      case "charteRP":
        return (
          <>
            <h2>Charte Réseau Pro</h2>
            <h6>Charte Réseau Pro</h6>
            <ReactQuill
              theme="snow"
              modules={QuillOptions.modules}
              formats={QuillOptions.formats}
              rows={5}
              name="charteRP"
              value={charteRP.content}
              onChange={(e) =>
                setCharteRP({
                  ...charteRP,
                  content: e,
                })
              }
            />
          </>
        );

      case "charteRPAlumni":
        return (
          <>
            <h2>Charte Réseau Pro Alumni</h2>
            <h6>Charte Réseau Pro Alumni</h6>
            <ReactQuill
              theme="snow"
              modules={QuillOptions.modules}
              formats={QuillOptions.formats}
              rows={5}
              name="charteRPAlumni"
              value={charteRPAlumni.content}
              onChange={(e) =>
                setCharteRPAlumni({
                  ...charteRPAlumni,
                  content: e,
                })
              }
            />
          </>
        );
      default:
        break;
    }
  }
  //? Navigation latérale
  function setMenu(item) {
    switch (item) {
      case "presentationRP":
        setOpenMenu("presentationRP");
        break;
      case "presentationRPAlumni":
        setOpenMenu("presentationRPAlumni");
        break;
      case "partieRP":
        setOpenMenu("partieRP");
        break;
      case "presentationUniv":
        setOpenMenu("presentationUniv");
        break;
      case "rejoindreRP":
        setOpenMenu("rejoindreRP");
        break;
      case "charteRP":
        setOpenMenu("charteRP");
        break;
      case "charteRPAlumni":
        setOpenMenu("charteRPAlumni");
        break;
      default:
        break;
    }
  }

  return (
    <div className="gestion_editoriale">
      <Toast ref={successUpdate} />
      {props.auth.isConnected && (
        <div className="gestion_editoriale__container">
          <div className="gestion_editoriale__container__title">
            <h1 className="h1_trait_dessus">
              {props.items[props.activeIndex].label}
            </h1>
            <div className="gestion_editoriale__container__title__filtre">
              {findDate(openMenu)}
            </div>
          </div>
          <div className="gestion_editoriale__container__content">
            <div className="menu_vertical">
              <h2 className="top">AVANT CONNEXION</h2>
              <h3
                onClick={() => setMenu("presentationRP")}
                className={setClass("presentationRP")}
              >
                Présentation Réseau Pro
              </h3>
              <h3
                onClick={() => setMenu("presentationRPAlumni")}
                className={setClass("presentationRPAlumni")}
              >
                Présentation Réseau Pro Alumni
              </h3>
              <h3
                onClick={() => setMenu("partieRP")}
                className={setClass("partieRP")}
              >
                Nos universités - Faire partie de Réseau Pro
              </h3>
              <h3
                onClick={() => setMenu("presentationUniv")}
                className={setClass("presentationUniv")}
              >
                Nos universités - Présentation de votre université
              </h3>
              <h3
                onClick={() => setMenu("rejoindreRP")}
                className={setClass("rejoindreRP")}
              >
                Espace recruteur
              </h3>
              <h2>APRÈS CONNEXION</h2>
              <h3
                onClick={() => setMenu("charteRP")}
                className={setClass("charteRP")}
              >
                Charte Réseau Pro
              </h3>
              <h3
                onClick={() => setMenu("charteRPAlumni")}
                className={setClass("charteRPAlumni")}
              >
                Charte Réseau Pro Alumni
              </h3>
            </div>
            <div
              className="gestion_editoriale__container__content__right"
              key={openMenu}
            >
              {getContent(openMenu)}
              <BtnBleu
                btnTexte="Mettre à jour"
                loading={loading}
                btnAction={() => {
                  putDataToApi();
                  setLoading(true);
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

GestionEditoriale.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.array,
  activeIndex: PropTypes.number,
  checked: PropTypes.bool,
  setChecked: PropTypes.func,
  admin: PropTypes.object,
  handleAdmin: PropTypes.func,
  universities: PropTypes.object,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  admin: state.admin,
  universities: state.universities,
});

const mapDispatchToProps = (dispatch) => ({
  handleAdmin: (value) => {
    dispatch(updateAdmin(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(GestionEditoriale);
